import { InputBase, useTheme } from "@mui/material";
import type { ChangeEvent, FC } from "react";
import type { AmountStepperSize } from "web_myplann/Shared/Types/AmountStepperSize";
import { numberFormatter } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	size: AmountStepperSize;
	id?: string;
	value: number;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	onDone: () => void;
};

export const AmountStepperInput: FC<Props> = ({
	size,
	id,
	value,
	onChange,
	onDone,
}) => {
	const { typography, amountStepper } = useTheme();
	const { variant, inputBox } = amountStepper.value[size];

	return (
		<InputBase
			autoFocus
			id={id}
			value={value === 0 ? "" : numberFormatter.format(value)}
			onChange={onChange}
			onBlur={onDone}
			onKeyDown={(event) => {
				if (event.key === "Enter") {
					event.preventDefault();
					onDone();
				}
			}}
			inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
			sx={{
				...inputBox,
				"& input": {
					p: 0,
					textAlign: "center",
					...typography[variant],
					fontVariantNumeric: "tabular-nums",
				},
			}}
		/>
	);
};
